module.exports = __webpack_public_path__ + "static/dcom3-768x638-a68d48924a1fb1bc83234e3d50df9124.png";